module.exports = __webpack_public_path__ + "img/hongkong.78ba9cda.svg";